<template>
  <div id="app">
    
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/*每个页面公共css */
*{margin:0;padding:0}
    [v-cloak]{
        display: none;
    }
	.flex_c{
		display: flex;
		display: -webkit-flex;
		align-items: center;
		-webkit-align-items: center;
		justify-content: center;
		-webkit-justify-content: center;
	}
	.flex_sb{
		display: flex;
		display: -webkit-flex;
		align-items: center;
		-webkit-align-items: center;
		justify-content: space-between;
		-webkit-justify-content: space-between;
	}
	.flex_start{
		display: flex;
		display: -webkit-flex;
		align-items: center;
		-webkit-align-items: center;
		flex-wrap: wrap;
		-webkit-flex-wrap: wrap;
	}
	image,img{
		display: block;
		margin: auto;
		border: none;
	}
	.window{
		position: fixed;
		width: 100vw;
		height: 100vh;
		top: 0;
		left: 0;
		z-index: 10;
		background: rgba(0,0,0,.6);
		overflow-x: hidden;
	}
	.window .w_content{
		position: relative;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
  }
  .Dialog,
  .van-dialog
  {
    width:auto;
    font-size:28px;
    background-color: rgba(0,0,0,.6) !important;
    color:#fff;
    padding:10px 20px;
    box-sizing:border-box;
  }

  .Dialog .van-dialog__message,
  .Dialog .van-dialog__header{
	  font-size:32px;
	  line-height:50px;
  }
  input{
	  outline: none;
	  border: none;
  }
  .van-loading__text,
  .van-list__finished-text{
      color: #999;
	  font-size: 24px  !important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue